module.exports = __webpack_public_path__ + "static/TT-Floorplan-Floor05-70e0e9a1390f1b22c95420c96c08c667.jpg";